/*eslint-disable*/
export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('slt');
    function accordian() {

      let action = 'click';
      let speed = "500";

      $('.c-builder__faq__title').on(action, function (e) {
        $(this).next().slideToggle(speed).siblings('.c-builder__faq__single-text').slideUp();
        $(this).toggleClass('clicked').siblings('.c-builder__faq__title').removeClass('clicked');

        let img = $(this).children('svg');
        $('svg').not(img).removeClass('rotate');
        img.toggleClass('rotate');
        e.preventDefault();
      });
    }
    accordian();

    $( ".wysiwyg table" ).wrap( "<div class='c-builder__table-container'></div>" );
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/builder.js